// announcement marque
$(".announcement__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    infinite: true
});


// hero wave
$(".hero-wave__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 25000,
    cssEase: "linear",
    // variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    infinite: true
});

// footer-wave
$(".footer-wave__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 25000,
    cssEase: "linear",
    // variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    infinite: true
});



// action slider
$(document).ready(function () {
    // Initialize the content slider
    $(".action__content-items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        arrows: false,
        infinite: true,
        fade: false,
        asNavFor: ".action__img-items"
    });

    // Initialize the image slider
    $(".action__img-items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".action__content-items",
        arrows: false,
        dots: false,
        infinite: true,
        fade: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    vertical: false
                }
            }
        ]
    });

    // Add click event to count items
    $('.action__count-item').click(function (e) {
        e.preventDefault();
        var slideno = $(this).attr('data-slide');
        $('.action__content-items').slick('slickGoTo', slideno - 1);
        $('.action__count-item').removeClass('active');
        $(this).addClass('active');
    });

    // Add afterChange event listener to content slider
    $(".action__content-items").on('afterChange', function (event, slick, currentSlide) {
        console.log('Content slider changed to slide:', currentSlide); // Debug log
        $('.action__count-item').removeClass('active');
        $('.action__count-item[data-slide="' + (currentSlide + 1) + '"]').addClass('active');
    });

    // Add afterChange event listener to image slider
    $(".action__img-items").on('afterChange', function (event, slick, currentSlide) {
        console.log('Image slider changed to slide:', currentSlide); // Debug log
        $('.action__count-item').removeClass('active');
        $('.action__count-item[data-slide="' + (currentSlide + 1) + '"]').addClass('active');
    });
});




// faq

$('.img-slider__content-text').hide();
// $('.img-slider__content-title:first').addClass('active').next('.img-slider__content-text').show();
$('.img-slider__content-title').off("click").on("click", function () {
    var img = $(this).attr('data-img')
    $('.img-slider__content-title').not(this).removeClass('active').next('.img-slider__content-text').slideUp();
    $(this).toggleClass('active').next('.img-slider__content-text').slideToggle();
    $(".img-slider__img").attr("src", img);
});



// prodcuts tab

$(".products__tab").on("click", function () {
    // Remove "active" class from all buttons and frames
    $(".products__items").removeClass("active");
    $(".products__tab").removeClass("active");

    // Get the data-tab attribute value
    var tabId = $(this).attr("data-tab");

    // Add "active" class to the clicked button and show the selected frame
    $(this).addClass("active");
    $("#" + tabId).addClass("active");
});



// impact slider
$(".impact__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    dots: true,
    adaptiveHeight: true,
    // variableWidth:true,
    centerMode: false,
    initialSlide: 0,
    mobileFirst: true,
    arrows: false,
    infinite: true,
    responsive: [
        {
            breakpoint: 480,
            settings: {
                infinite: true,
                slidesToShow: 2,
                // centerMode: true,
                // focusOnSelect: true,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                infinite: true,
                mobileFirst: true,
                centerMode:true,
                variableWidth:true,
                centerPadding: '0px',
                focusOnSelect: true,
                initialSlide: 1,
                // variableWidth: true,
            },
        },
        {
            breakpoint: 2359,
            settings: {
                infinite: true,
                slidesToShow: 3,
                variableWidth: true,
                initialSlide: 1,
                centerMode:true,
                // centerMode: true,
                // focusOnSelect: true,
            },
        },
        // {
        //     breakpoint: 2359,
        //     settings: "unslick"
        // },
    ],
});

$('.impact__arrow_left').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.impact__arrow_right').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});





// products
$(".products__items").slick({
    dots: false,
    slidesToShow: 3,
    arrows: false,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                initialSlide: 2,
                centerMode: true,
                centerPadding: '97px',
            }
        },
        {
            breakpoint: 768,
            settings: {
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                pauseOnHover: false,
                centerMode: false,
            },
        },
    ],
});

$('.products__btn_left').click(function () {
    $(this).parent().parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.products__btn_right').click(function () {
    $(this).parent().parent().parent().parent().find('.slick-slider').slick('slickNext');
});

// partners marque
$(".partners__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    infinite: true
});

// Insta marque
$(".insta__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    infinite: true
});




// climate tab-faq
if ($(window).width() < 768) {

    $('.climate-tabs__content').hide();
    $('.climate-tabs__title:first').addClass('active').next('.climate-tabs__content').show();
    $('.climate-tabs__title').off("click").on("click", function () {
        $('.climate-tabs__title').not(this).removeClass('active').next('.climate-tabs__content').slideUp();
        $(this).toggleClass('active').next('.climate-tabs__content').slideToggle();
    });
}



$(".climate-tabs__btn").on("click", function () {
    // Remove "active" class from all buttons and frames
    $(".climate-tabs__item").removeClass("active");
    $(".climate-tabs__btn").removeClass("active");

    // Get the data-tab attribute value
    var tabId = $(this).attr("data-tab");

    // Add "active" class to the clicked button and show the selected frame
    $(this).addClass("active");
    $("#" + tabId).addClass("active");
});


// gallery marque
// announcement marque
$(".gallery__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    infinite: true
});





// faqs

$('.faqs__content').hide();
$('.faqs__title:first').addClass('active').next('.faqs__content').show();
$('.faqs__title').off("click").on("click", function () {
    $('.faqs__title').not(this).removeClass('active').next('.faqs__content').slideUp();
    $(this).toggleClass('active').next('.faqs__content').slideToggle();
});


// forms slider
if ($(window).width() < 768) {
    $(".forms__items").slick({
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    pauseOnHover: false,
                },
            },
        ],
    });
}


// sourcing - tabs progress
document.addEventListener('DOMContentLoaded', function () {
    const progresses = document.querySelectorAll('.progress-done');
    progresses.forEach(progress => {
        progress.style.width = progress.getAttribute('data-done') + '%';
        progress.style.opacity = 1;
    });
});





// sourcing tabs
$(".sourcing-tabs__btn").on("click", function () {
    // Remove "active" class from all buttons and frames
    $(".sourcing-tabs__item").removeClass("active");
    $(".sourcing-tabs__btn").removeClass("active");

    // Get the data-tab attribute value
    var tabId = $(this).attr("data-tab");

    // Add "active" class to the clicked button and show the selected frame
    $(this).addClass("active");
    $("#" + tabId).addClass("active");
});


// header drawer mobi toggle
// faqs

$('.mobi-drawer__sub-item-wrap').hide();
// $('.has-child-menu:first').addClass('active').next('.mobi-drawer__sub-item-wrap').show();
$('.has-child-menu').off("click").on("click", function (e) {
    e.preventDefault();
    $('.has-child-menu').not(this).removeClass('active').next('.mobi-drawer__sub-item-wrap').slideUp();
    $(this).toggleClass('active').next('.mobi-drawer__sub-item-wrap').slideToggle();
});


// hamburger






// header drawer
const $hamWrapper = $(".header__ham ");
const $navMenu = $(".header__drawer-mobi");
const $menuClose = $(".header__cross");

$hamWrapper.on("click", function () {
    $(this).removeClass("active");
    $menuClose.addClass("active");
    $navMenu.addClass("active");
    $('body').addClass('menu-opened');
});

$menuClose.on("click", function () {
    $navMenu.removeClass("active");
    $(this).removeClass("active");
    $hamWrapper.addClass("active");
    $('body').removeClass('menu-opened');
    $("body").removeClass("desk-menu-opened");
});



// desktop menu drawer
$(document).ready(function () {
    $(".header__menu").on("click",".has-subitem", function (e) {
        e.preventDefault();
        $('.menu-backdrop').fadeIn();
        $(this).toggleClass("active");
        $(this).next(".header__menu-subitems").toggleClass("active");
        $(".has-subitem").not(this).removeClass("active");
        $(".header__menu-subitems").not($(this).next()).removeClass("active");
        if ($(".has-subitem.active").length > 0) {
            $("body").addClass("active");
            $("body").addClass("desk-menu-opened");
        } else {
            $("body").removeClass("active");
            $("body").removeClass("desk-menu-opened");
            $('.menu-backdrop').fadeOut();
        }
      

    });
    $(".body-wrap").on("click", function () {
        $(this).removeClass("active");
        $(this).removeClass("active-cart");
        $(".has-subitem").removeClass("active");
        $(".header__menu-subitems").removeClass("active");
        $(".cart-drawer").removeClass("active");
        $("body").removeClass("active");
        $("body").removeClass("desk-menu-opened");
    });
});

$('.menu-backdrop').click(function () {
    $(this).fadeOut();
    $(".has-subitem").removeClass("active");
    $(".header__menu-subitems").removeClass("active");
    $("body").removeClass("active");
    $("body").removeClass("desk-menu-opened");
});


document.body.addEventListener('keydown', function(e) {
  if (e.key == "Escape") {
     $('.menu-backdrop').fadeOut();
        $(".has-subitem").removeClass("active");
        $(".header__menu-subitems").removeClass("active");
        $("body").removeClass("active");
        $("body").removeClass("desk-menu-opened");
        $(".cart-drawer").removeClass("active");
        $(".body-wrap").removeClass("active-cart");
  }

  
  
});





// logo-txt
if ($(window).width() < 768) {
    $(".logo-txt__items").slick({
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    pauseOnHover: false,
                },
            },
        ],
    });
}


// faq-page
$('.faq-page__bot').hide();
// $('.faq-page__top:first').addClass('active').next('.faq-page__bot').show();
$('.faq-page__top').off("click").on("click", function () {
    $('.faq-page__top').not(this).removeClass('active').next('.faq-page__bot').slideUp();
    $(this).toggleClass('active').next('.faq-page__bot').slideToggle();
});



// related-article
if ($(window).width() < 768) {
    $(".related-article__items").slick({
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    pauseOnHover: false,
                },
            },
        ],
    });
}



// account drawer
function setupAccountDrawer() {
    $(".customer-drawer").addClass("active");
    $(".body-wrap").addClass("active_account");
    $("body").addClass("ac-drawer-opened");
}
function removeAccountDrawer() {
    $(".customer-drawer").removeClass("active");
    $(".body-wrap").removeClass("active_account");
    $("body").removeClass("ac-drawer-opened");
}

$(".header__account_drawer").on("click", function (e) {
    e.preventDefault();
    setupAccountDrawer();
});

$(".mobi-drawer__item-account").on("click", function (e) {
    e.preventDefault();
    setupAccountDrawer();
});

$(".body-wrap").on("click", function () {
    $(".customer-drawer").removeClass("active");
    $(this).removeClass("active_account");
    removeAccountDrawer();
});

$(".customer-drawer__cross").on("click", function () {
    removeAccountDrawer();
});

$(".customer-login__create").on("click", function () {
    setupAccountDrawer();
    $(".drawer__panels").removeClass("active");
    $(".customer-create").addClass("active");
    $(".customer-drawer__title").html("CREATE ACCOUNT")
});

$(".customer-create__already").on("click", function () {
    setupAccountDrawer();
    $(".drawer__panels").removeClass("active");
    $(".customer-login").addClass("active");
    $(".customer-drawer__title").html("LOGIN")
});

$(".customer-login__forgot").on("click", function () {
    setupAccountDrawer();
    $(".drawer__panels").removeClass("active");
    $(".customer-reset-init").addClass("active");
    $(".customer-drawer__title").html("RESET PASSWORD")
});

$(".add-address").on("click", function () {
    setupAccountDrawer();
    $(".drawer__panels").removeClass("active");
    $(".customer-create-address").addClass("active");
    $(".customer-drawer__title").html("CREATE ADDRESS")
});



$(".edit-address").on("click", function () {
    setupAccountDrawer();
    $(".drawer__panels").removeClass("active");
    $(".customer-edit-address").addClass("active");
    $(".customer-drawer__title").html("EDIT ADDRESS");

    var form_data = $(this).attr('data-form');

    $('.customer-edit-address__form').each(function () {
        var form_id = $(this).attr('id');
        if (form_data === form_id) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
});



$(".customer-update__country").each(function () {
    var e = $(this).attr("data-default");
    // $(this).val(e), console.log(e)
})


if (window.location.pathname == '/account/login') {
    setupAccountDrawer();
    $(".drawer__panels").removeClass("active");
    $(".customer-login").addClass("active");
    $(".customer-drawer__title").html("LOGIN")
}
if (window.location.pathname == '/account/register') {
    setupAccountDrawer();
    $(".drawer__panels").removeClass("active");
    $(".customer-create").addClass("active");
    $(".customer-drawer__title").html("CREATE ACCOUNT")
}



$(document).ready(function () {
    $('.address__delete').on('click', function (event) {
        event.preventDefault();
        if (confirm('Are you sure you want to delete this address?')) {
            $(this).closest('form').submit();
        }
    });
});




$(".single-product__items").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    adaptiveHeight: true,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: "unslick"
        },
    ],
});


// subscribe product
$(".subscribe-product__items").slick({
    dots: false,
    slidesToShow: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                pauseOnHover: false,
            },
        },
    ],
});

// brand
$(".brand__items").slick({
    dots: false,
    slidesToShow: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick",
        },
        {
            breakpoint: 768,
            settings: {
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                pauseOnHover: false,
            },
        },
    ],
});




// Testimonial
if ($(window).width() < 768) {
    $(".testimonial__items").slick({
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    pauseOnHover: false,
                },
            },
        ],
    });
}



// related products
$(".related-products__items").slick({
    dots: false,
    slidesToShow: 3,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 768,

            settings: {
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                pauseOnHover: false,
            },
        },
    ],
});




// press slider

$(".press-slider__content-items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    arrows: false,
    fade: false,
    asNavFor: ".press-slider__img-items",
});

$(".press-slider__img-items").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".press-slider__content-items",
    arrows: false,
    dots: false,
    focusOnSelect: true,
    centerMode: false,
    focusOnSelect: true,
    vertical: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                centerMode: false,
                focusOnSelect: true,
                vertical: false,
                dots: true,
            },
        },
    ],
});


// cart-drawer

$(".header__cart").on("click", function (e) {
    e.preventDefault();
    $(".cart-drawer").addClass("active");
    $(".body-wrap").addClass("active-cart");
    $("body").addClass("active");
})


function cartClose() {

    $(".cart-drawer").removeClass("active");
    $(".body-wrap").removeClass("active-cart");
    $("body").removeClass("active");

}




// variant update single page

function selectedVarint() {
    var slectedId = $(".selected-product").val();
    console.log(slectedId);
    var url = new URL(window.location.href);
    url.searchParams.set("variant", slectedId);
    window.history.replaceState({}, "", url);
}
function selectedUpdate() {
    var updateValue = "";
    $(".single-product__variant input[type='radio']:checked").each(
        function () {
            updateValue += (updateValue ? " / " : "") + $(this).val();
        }
    );

    
    $(".selected-product option").each(function () {
        var optionValue = $(this).text().trim();
        if (optionValue == updateValue) {
            $(this).prop("selected", true);
            console.log(updateValue);
            // var check = $(".single-product__variant input[type='radio']:checked")
            var price = $(this).attr('data-price');
            var discount = $(this).attr('data-discount');
            // console.log(price);
            $('.single-product__purchase-price_one-time').html(price);
            $('.single-product__purchase-price_subscribe').html(discount);
            $('.single-product__btn .discount-price').html(discount);
            $('.single-product__btn .regular-price').html(price);
            return true;            
        }
    });
}
$(".single-product__variant input[type='radio']").change(function () {
    selectedUpdate();
    selectedVarint();
});






// variant update collection
var def_price = "subs";
$(".collection-item__variant-input").change(function () {
    // var cases = $(this).parent().parent().find(".collection-item__variant-input:checked").attr('cases');
    var prodPrice = $(this).parent().parent().find(".collection-item__variant-input:checked").attr('case-price');
    var prodSubPrice = $(this).parent().parent().find(".collection-item__variant-input:checked").attr('subscription-price');
    if(def_price == "subs"){
        $(this).parent().parent().parent().parent().parent().find('.per-case-price').text(prodSubPrice);

    }else{
        $(this).parent().parent().parent().parent().parent().find('.per-case-price').text(prodPrice);
    }
    
    $(this).parent().parent().parent().find('.collection-item__oneTime-plan-price').text(prodPrice);
});

if($('.collection-item-grouped').length > 0){
    $('.collection-group-trigger').on('click', function(){
        if(!$(this).hasClass('active')){
            let target = $(this).parent().data('target'),
            tabIndex = $(this).data('tab-index'),
            pd = $(this).data('pd'),
            imgGroup = $('.collection-item-'+pd+' .'+target+'-img-'+tabIndex),
            formGroup = $('.collection-item-'+pd+' .'+target+'-form-'+tabIndex);

            $('.collection-item-'+pd+' .collection-group-trigger').removeClass('active');
            $('.collection-item-'+pd+' .group-image-tab').removeClass('active');
            $('.collection-item-'+pd+' .collection-item-form').removeClass('active');

            $(this).addClass('active');
            imgGroup.addClass('active');
            formGroup.addClass('active');

        }


    });
}










// section rendering

function rendering() {
    fetch("?section_id=cart-drawer")
        .then((res) => res.text())
        .then((data) => {
            var cart__html = $(data);
            var render__html = $(".cart-drawer__inner", cart__html);
            $(".cart-drawer__inner").replaceWith(render__html);
          $('.cart-drawer__minus, .cart-drawer__plus, .cart-drawer__title span, .cart-drawer__top-right, .cart-drawer__upsell-btn')
        .attr('tabindex', '0');
        });

    fetch("?section_id=header")
        .then((res) => res.text())
        .then((data) => {
            var html_data = $(data);
            var render__html = $(".header__cart-count", html_data);
            $(".header__cart-count").replaceWith(render__html);
        });
  
}






// add to cart

$(".single-product__btn").on("click", function (e) {
    e.preventDefault();
    var formData = $('.single__product-form').serialize();
    console.log(formData);
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: formData,
        success: function (data) {
            // openCart(true);
            rendering();
            $("body").addClass("active");
            $(".cart-drawer").addClass("active");
            $(".body-wrap").addClass("active-cart");
        },
        error: function (err) {
            console.log(err);
        },
    });
});

$(document).on("click", ".collection__btn", function (e) {
    e.preventDefault();
    let formTarget = '.product-form-'+$(this).data('form');
    var formData = $(formTarget).serialize();
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: formData,
        success: function (data) {
            rendering();
            $("body").addClass("active");
            $(".cart-drawer").addClass("active");
            $(".body-wrap").addClass("active-cart");
        },
        error: function (err) {
            console.log(err);
        },
    });
});














// variant update single page

function selectedVariant() {
    var selectedId = $(".subscribe-product__selected").val();

    console.log('hi' + selectedId);
    var url = new URL(window.location.href);
    url.searchParams.set("variant", selectedId);
    window.history.replaceState({}, "", url);
}
function selectedUpdated() {
    var updateValue = "";
    $(".subscribe-product__case-wrap input[type='radio']:checked").each(
        function () {
            updateValue += (updateValue ? " / " : "") + $(this).val();
            // updateValue = $(this).val();
        }
    );
    $(".subscribe-product option").each(function () {
        var optionValue = $(this).text().trim();
        if (optionValue == updateValue) {
            $(this).prop("selected", true);


            return true;
        }
    });
}
// $(".subscribe-product__case-wrap input[type='radio']").change(function () {
//     selectedUpdated();
//     selectedVariant();
// });
$(document).on("change", ".subscribe-product__case-wrap input[type='radio']", function () {
    console.log('changed"');
    selectedUpdated();
    selectedVariant();
});









// subscribe product

$(document).on("click", ".subscribe-product__btn", function (e) {
    e.preventDefault();
    var formData = $(this).parent().parent().parent().find('.subscribe-product__form').serialize();
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: formData,
        success: function (data) {
            rendering();
            $("body").addClass("active");
            $(".cart-drawer").addClass("active");
            $(".body-wrap").addClass("active-cart");
        },
        error: function (err) {
            console.log(err);
        },
    });
});






















// upsell

function cartDrawerUpsell(e) {

    // e.preventDefault();
    var formData = $('.cart-drawer__form').serialize();
    console.log(formData);
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: formData,
        success: function (data) {
            // openCart(true);
            rendering();
        },
        error: function (err) {
            console.log(err);
        },
    });
}











function increment(el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value);
    value = isNaN(value) ? 0 : value
    value++;
    // console.log(input);

    input.value = value;
    changeQuantity(input)

}
function decrement(el) {
    var input = el.nextElementSibling;
    // console.log(input);
    var value = parseInt(input.value);
    if (value > 0) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
        changeQuantity(input)


    }
}
function changeQuantity(input) {
    var quantity = $(input).val();
    var data_line = $(input).attr("data-line");
    // console.log(quantity);
    var data = {
        "line": data_line,
        "quantity": quantity

    };

    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
        success: function (data) {
            // console.log(data);
            rendering();
        },
        error: function (err) {
            console.log("Error from quantity update")
        }
    })
}




// remove item form cart
function itemRemove(e, el) {
    e.preventDefault();

    var data_line = $(el).attr("data-line");

    var data = {
        "line": data_line,
        "quantity": 0
    }
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
        success: function (data) {
            rendering()
        }
    })
}








Number.prototype.format = function (n) {
    var r = new RegExp('\\d(?=(\\d{3})+' + (n > 0 ? '\\.' : '$') + ')', 'g');
    return this.toFixed(Math.max(0, Math.floor(n))).replace(r, '$&,');
};

// $('.plastic-count h3').each(function () {
//     $(this).prop('counter', 0).animate({
//         counter: $(this).text()
//     }, {
//         duration: 100000,
//         easing: 'easeOutExpo',
//         step: function (step) {
//             $(this).text('' + step.format());
//         }
//     });
// });


var startVal = 1;
function increase() {
  setTimeout(function(){
    var theVal = startVal + 85; 
    startVal = theVal;
    increase();
    $('.plastic-count h3').text(startVal.toLocaleString());
  }, 1);
}
increase();




// Viewport
$.fn.isInViewport = function () {
    try {
        var elementTop = $(this).offset().top + 200;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }
    catch (err) {
        return false;
    }
};

// $('.anim').each(function () {
//     if ($(this).isInViewport()) {
//         $(this).addClass('do-anim');
//     } else {
//         console.log('Not in view port');
//     }
// });


var animCount = "true";
$(window).on('resize scroll', function () {
    $('.anim').each(function () {
        if ($(this).isInViewport()) {
            $(this).addClass('do-anim');
        } 
    });
    $('.story-line__item_anim').each(function () {
        if ($(this).isInViewport()) {
            $(this).addClass('story-line__item_do-anim');
        } 
    });

    $('.countdown__count span').each(function () {
        if ($(this).isInViewport()) {
            if (animCount == 'true') {
                animCount = "false";
                $('.countdown__count span').countTo({
                    speed: 3000,
                });
            }

        }
    });

    // var waveTop = $(window).scrollTop() / 2;
    // $('.hero-wave__items').css('left', '-' + waveTop + 'px');
});


$('.collection__tab').click(function () {
    $('.collection__tab').removeClass('active');
    $(this).addClass('active');
    var selectedCollection = $(this).attr('data-products');
    fetch(selectedCollection + "?section_id=main-collection-product-grid")
        .then((res) => res.text())
        .then((data) => {
            var col_items = $(data);
            var render__html = $(".collection__grid", col_items);
            $(".collection__grid").replaceWith(render__html);
        });
})



$(".subscribe-product__select_product").change(function () {
    var selectedProduct = $(this).val();

    fetch(selectedProduct + "?section_id=subscribe-product-single-page")
        .then((res) => res.text())
        .then((data) => {
            var sub_item = $(data);
            var render__html = $(".subscription-form-wrap", sub_item);
            $(".subscription-form-wrap").replaceWith(render__html);

            var gallery__html = $(".subscribe-product__items", sub_item);
            $(".subscribe-product__items").replaceWith(gallery__html);
            $(".subscribe-product__items").slick({
                arrows: false
            });
        });
});



var lastScrollTop = 0;
$(window).scroll(function (event) {
    var scroll = $(this).scrollTop();
    if (scroll > lastScrollTop) {
        $("body").removeClass("header-fixed_visible");
        if (scroll >= 32) {
            $("body").addClass("header-fixed");
        } else {
            $("body").removeClass("header-fixed");
        };
    } else {
        if (scroll >= 32) {
            $("body").addClass("header-fixed_visible");
        } else {
            $("body").removeClass("header-fixed_visible");
            $("body").removeClass("header-fixed");
        }
    }
    lastScrollTop = scroll;
});



// selling plan name change
$('.single-product__radio-input').change(function() {
    if ($('#subscribe').is(':checked')) {
      console.log('subscribe checked');
        $('.single-product__subscribe-select').attr('name', 'selling_plan');
        $('.subs-stat').attr('name', 'selling_plan');
        $('.single-product__btn span.atc-text').text('subscribe');
    } else {
      console.log('onetime checked');
        $('.single-product__subscribe-select').attr('name', '');
        $('.subs-stat').attr('name', '');
        $('.single-product__btn span.atc-text').text('add to cart');
    }
   if ($(this).is(":checked")) {
        $('.single-product__btn span').toggleClass("active");
    }
    else {
        $('.single-product__btn span').toggleClass("active");
    }

})
// collection-page subscribe

function subscribe() {

    $(this).children(":first").children(":first").addClass('active')
    $(this).next().children().removeClass('active')
    let planTarget = $(this).data('plan-target'),
    planPrice = $(this).data('price');
    $('.'+planTarget).attr('name','selling_plan');

    let priceTargetID = planTarget.replace('selling-plan-input-', '');
    $('.collection__btn[data-form="'+priceTargetID+'"] .per-case-price').html(planPrice);
    $('.collection__btn[data-form="'+priceTargetID+'"] .atc-text').html('Subscribe');
    // var s_price = $(this).parent().parent().find(".collection-item__variant-input:checked").attr('subscription-price');
    // $(this).parent().parent().parent().parent().find('.per-case-price').text(s_price);
    
}


function oneTime() {
    $(this).children(":first").addClass('active')
    $(this).prev().children().children().removeClass('active')
    let planTarget = $(this).data('plan-target'),
    planPrice = $(this).data('price');
    $('.'+planTarget).attr('name','');
    let priceTargetID = planTarget.replace('selling-plan-input-', '');
    $('.collection__btn[data-form="'+priceTargetID+'"] .per-case-price').html(planPrice);
    $('.collection__btn[data-form="'+priceTargetID+'"] .atc-text').html('Add to cart');
    // var r_price = $(this).parent().parent().find(".collection-item__variant-input:checked").attr('case-price');
    // $(this).parent().parent().parent().parent().find('.per-case-price').text(r_price);
}
$('.collection-item__subscribe-plan-select').on('change', function(){
    let planTarget = $(this).data('plan-target');
    let planID = $(this).val();
    $('.'+planTarget).val(planID);
})

window.addEventListener("DOMContentLoaded", e =>
    {
      document.querySelectorAll('a[href]').forEach(a =>
      {
        if (location.hostname == new URL(a.href).hostname)
          return;
    
        a.target = "_blank";
        a.rel = "noreferrer nofollow noopener";
      });
    });






    // footer slider
    if ($(window).width() < 768) {
     $(".footer__bottom-right ul").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
        infinite: true
    });       
    }


    // product sticker
//     if ($(window).width() > 767) {
//     var firstImage = $('.single-product__img img').first();

//     firstImage.on('load', function () {
//         var firstImageHeight = $(this).height();    
    
//         console.log('Image height:', firstImageHeight); // Log the image height
    
//         var adjustedTop = firstImageHeight + 129;
    
//         $('.single-product__sticker').css('top', adjustedTop + 'px');
//     }).each(function() {
//         // If the image is already loaded, manually trigger the load event
//         if (this.complete) $(this).trigger('load');
//     });
// }


// selling plan id select
$(document).on("change",".single-product__subscribe-select",function() {
    var drop_selected = $(this).closest('div').find('select option:selected').text();
    var drop_id = $(this).val();
    
    $('.subs-stat').val(drop_id);
    // $(this).parent().parent().find('.dropdown__stat span').text(drop_selected);
  });




// cookies
/*
document.addEventListener('DOMContentLoaded', function () {
    var cookieBanner = document.querySelector('.cookies');
    var acceptButton = document.querySelector('.cookies__btn');
    var cookieName = 'cookies_accepted';
    // Check if the user has already accepted the cookies
    if (!getCookie(cookieName)) {
        cookieBanner.style.display = 'block';
    }
    // When the user accepts cookies
    acceptButton.addEventListener('click', function () {
        setCookie(cookieName, 'true', 365);
        cookieBanner.style.display = 'none';
    });
    // Helper function to set a cookie
    function setCookie(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
    // Helper function to get a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});*/